import { SubpageContentBlocks } from "@components/page/SubpageContentBlocks"
import { defineView } from "eddev/views"

export default defineView("single-tff-center", (props) => {
  return (
    <div>
      <SubpageContentBlocks blocks={props.tffCenter?.contentBlocks} />
      <div className="h-10" />
    </div>
  )
})
